import React, { Component } from 'react';
import { header } from 'constants/table';
import { RowItemCapNhatNguoiDungXLD } from './datatable/list';
import { Input, DropDownMultipleSelect } from 'components/tt-forms/common';
import { MasterLayout } from 'layout';
import { Danhmuc } from 'api';
import { Link } from 'react-router';
import { get, isEmpty } from 'lodash';
import { DataTableMultipleSelect } from 'modules/thanh-tra/datatable';
import classnames from 'classnames';
import { Dialog } from "@blueprintjs/core";
import { Toastr } from 'modules/toastr';
import { DropDownMulipleUse } from 'components/tt-forms';

const listTrangThaiThanhLap = [
  {
    ten: 'Thành lập',
    giaTri: true
  },
  {
    ten: 'Chưa thành lập',
    giaTri: false
  },
]

class DanhSachDonTheoDonVi extends Component {
  constructor (props) {
    super(props);
    this.state = {
      dataTable: [],
      tenEmail: '',
      nguoiDungThayThe: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      openDialog: false,
      loadingTable: false,
      checkAll: false,
      searchLoading: false,
      loadingSelect: false,
      selectedOption: null,
      maHoSo: '',
      dataOptions: [],
      message: 'Xóa các đơn đã chọn',
      statusThanhLapDon: '',
      nam: ''
    }
  }

  componentDidMount() {
   this.getCoQuanQuanLy();
  }

  // Get data select đơn vịe
  getCoQuanQuanLy() {
    this.setState({
      loadingSelect: true
    })
    let params = {};
    Danhmuc.actions.getCoQuanQuanLyTimKiem.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        const { coQuanQuanLies } = res.data._embedded;
        const dataOptions = coQuanQuanLies.map(item => {
          return {
            label: item.ten || item.ma,
            value: item.coQuanQuanLyId || ''
          }
        })
        this.setState({
          dataOptions
        })
      }
    }).catch(error => {
    }).finally(() => {
      this.setState({
        loadingSelect: false
      })
    })
  }

  handleChange(selectedOption) {
    this.setState({ selectedOption }, () => {
      this.getDataList()
    });
  };

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  openDialog() {
    this.setState({
      openDialog: true
    })
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  // Validate Form
  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size
      }
    },() => {
      this.getDataList();
    })
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    },() => {
      this.getDataList();
    })
  }

  // Get data table
  getDataList() {
    if (this.validateSubmitForm()) {
      this.setState({
        loadingTable: true
      })
      const params = {
        donViId: (this.state.selectedOption && this.state.selectedOption.value) || '',
        maHoSo: this.state.maHoSo || undefined,
        nam: this.state.nam || undefined,
        thanhLapDon: this.state.statusThanhLapDon || undefined,
        page: this.state.pageData.number,
        size: this.state.pageData.size,
        sort: 'ngayTiepNhan,desc'
      }
      Danhmuc.actions.getDanhSachDonTheoDonVi.request(params).then(res => {
        const newData = !isEmpty(res, 'data._embedded') ? get(res, 'data._embedded.dons') : [];
        const pageData = get(res, 'data.page');
        this.setState({
          dataTable: newData,
          pageData
        })
      }).catch(error => {
      }).finally(() => {
        this.setState({
          listCheckedId: [],
          loadingTable: false,
          checkAll: false
        })
      })
    }
  }

  async handleSearch (e) {
    e.preventDefault();
    await this.getDataList();
  }

  // Chọn một đơn
  async handleSelectedDoiTuong(item) {
    item.selected = !item.selected;
    const donIdSelect = item.donId;
    let { listCheckedId } = this.state;
    if (item.selected) {
      listCheckedId.push(donIdSelect);
    } else {
      listCheckedId = listCheckedId.filter(item => item !== donIdSelect);
    }
    this.setState({
      listCheckedId
    })
  }

  // Chọn tất cả đơn
  handleSelectedAll() {
    const itemCheck = !this.state.checkAll;
    let { listCheckedId, dataTable } = this.state;
    if (itemCheck) {
      listCheckedId = dataTable.map(item => item.donId)
    } else {
      listCheckedId = []
    }
    dataTable = dataTable.map(item => {
      return {
        ...item,
        selected: itemCheck
      }
    })
    this.setState({
      checkAll: itemCheck,
      dataTable,
      listCheckedId
    });
  }

  // Handle xóa đơn
  handleDelete() {
    if (!isEmpty(this.state.listCheckedId)) {
      this.openDialog();
    }
  }

  onConfirmDialog() {
    const { listCheckedId } = this.state;
    if (!isEmpty(listCheckedId)) {
      this.setState({
        buttonLoading: true
      })
      const params = {
        donIds: listCheckedId,
      }
      Danhmuc.actions.deleteDonTrongDonVi.request(null, params).then(res => {
        this.getDataList();
        this.setState({
          checkAll: false,
          listCheckedId: []
        })
        Toastr('Xóa thành công', 'success');
      }).catch(error => {
        Toastr('Lỗi hệ thống', 'error');
      }).finally(() => {
        this.setState({
          nguoiDungThayThe: '',
          buttonLoading: false
        })
        this.closeDialog();
      })
    } else {
      Toastr('Chưa chọn đơn', 'thongbao');
    }
  }

  render () {
    const { dataOptions, searchLoading, listCheckedId } = this.state;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Danh sách đơn trong đơn vị</p>
            </div>
          </div>
          <div className="bottom-content">
            <form className="" onSubmit={this.handleSearch.bind(this)}>
              <div className='row pt20 pl25 pr25'>
                <div className="col-50">
                  <DropDownMultipleSelect
                    isSearchable
                    multi={false}
                    className="input-20"
                    label="Đơn vị"
                    bindValidator={this}
                    require={true}
                    channel='formTaoDon'
                    placeholder={{key: '', text: '--Chọn--'}}
                    loading={this.state.loadingSelect}
                    options={dataOptions}
                    onChange={this.handleChange.bind(this)}/>
                </div>
                <Input className='col-25' value={this.state.maHoSo} onChange={this.onChange.bind(this, 'maHoSo')} name='maHoSo' label='Mã hồ sơ' placeholder='Nhập mã hồ sơ...'/>
                <div className='col-25 mt22'>
                  <button type="submit" className={`pt-button btn-green tt-search ${this.state.loadingTable ? 'btn-loading-inline' : ''}`}>Tìm kiếm</button>
                </div>
              </div>
              <div className='row pl25 pr25 pb5'>
                <DropDownMulipleUse  className="col-25" label="Trạng thái" data={listTrangThaiThanhLap} keyName="giaTri" valueName="ten" selectedValue={this.state.statusThanhLapDon} onChange={this.onChange.bind(this, 'statusThanhLapDon')}/>
                <Input className='col-25' value={this.state.nam} onChange={this.onChange.bind(this, 'nam')} name='nam' label='Năm' placeholder='Nhập năm...'/>
              </div>
            </form>
            <div className="line-border"/>
            <div className="button-wrap-container">
              <Link
                className={classnames('btn-action btn-delete mr0', {
                  'btn-disable-tttp': isEmpty(listCheckedId),
                  'btn-loading-inline': searchLoading
                })}
                onClick={ this.handleDelete.bind(this)}
                ><span>Xóa đơn chọn</span></Link>
            </div>
            <DataTableMultipleSelect
              header={header.categoryGroup.capNhatNguoiDungXLD}
              dataList={this.state.dataTable}
              hideButtonExport
              pageData={this.state.pageData}
              parent={this}
              onDisableCheck={isEmpty(this.state.dataTable)}
              tableLoading={this.state.loadingTable}
              onCheck={this.handleSelectedAll.bind(this)}
              selectAllStatus={this.state.checkAll}
            >
              <RowItemCapNhatNguoiDungXLD/>
            </DataTableMultipleSelect>
          </div>
        </div>
        <Dialog
          isOpen={this.state.openDialog}
          onClose={this.closeDialog.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block">
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">{this.state.message}</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.onConfirmDialog.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </MasterLayout>
    )
  }
}

DanhSachDonTheoDonVi.defaultProps={
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
}

export default DanhSachDonTheoDonVi;



// WEBPACK FOOTER //
// ./src/components/modules/category/DanhSachDonTheoDonVi.jsx